import { DocumentIcon, ProfileIcon } from '../image'
import { COLORS } from './colors'
import { LANG_STRINGS } from './lang'

export const RESEND_OTP_COUNT_DOWN = 30000
export const WHATS_APP_NUMBER = 6281197009800

export const COUNTRY_CODES = [
  { value: '1', displayName: '+1', countryCode: 'CA' },
  { value: '1', displayName: '+1', countryCode: 'PR' },
  { value: '1', displayName: '+1', countryCode: 'US' },
  { value: '31', displayName: '+31', countryCode: 'NL' },
  { value: '32', displayName: '+32', countryCode: 'BE' },
  { value: '34', displayName: '+34', countryCode: 'ES' },
  { value: '36', displayName: '+36', countryCode: 'HU' },
  { value: '39', displayName: '+39', countryCode: 'IT' },
  { value: '41', displayName: '+41', countryCode: 'CH' },
  { value: '43', displayName: '+43', countryCode: 'AT' },
  { value: '44', displayName: '+44', countryCode: 'GB' },
  { value: '45', displayName: '+45', countryCode: 'DK' },
  { value: '46', displayName: '+46', countryCode: 'SE' },
  { value: '47', displayName: '+47', countryCode: 'NO' },
  { value: '48', displayName: '+48', countryCode: 'PL' },
  { value: '49', displayName: '+49', countryCode: 'DE' },
  { value: '52', displayName: '+52', countryCode: 'MX' },
  { value: '55', displayName: '+55', countryCode: 'BR' },
  { value: '56', displayName: '+56', countryCode: 'CL' },
  { value: '60', displayName: '+60', countryCode: 'MY' },
  { value: '61', displayName: '+61', countryCode: 'AU' },
  { value: '62', displayName: '+62', countryCode: 'ID' },
  { value: '63', displayName: '+63', countryCode: 'PH' },
  { value: '65', displayName: '+65', countryCode: 'SG' },
  { value: '66', displayName: '+66', countryCode: 'TH' },
  { value: '81', displayName: '+81', countryCode: 'JP' },
  { value: '82', displayName: '+82', countryCode: 'KR' },
  { value: '84', displayName: '+84', countryCode: 'VN' },
  { value: '86', displayName: '+86', countryCode: 'CN' },
  { value: '852', displayName: '+852', countryCode: 'HK' },
  { value: '886', displayName: '+886', countryCode: 'TW' },
  { value: '91', displayName: '+91', countryCode: 'IN' }
]

export const B2CNAVIGATION_LINKS = [
  {
    title: LANG_STRINGS.policy,
    link: '/?source=polis',
    isNonLinkApplicable: true
  },
  {
    title: LANG_STRINGS.claim,
    link: '/?source=claim'
  }
]

export const AGENCY_NAVIGATION_LINKS = [
  {
    title: LANG_STRINGS.agencyPolicy,
    link: '/?source=agency-policy'
  },
  {
    title: LANG_STRINGS.agencyClaim,
    link: '/?source=agency-claim'
  }
]

export const genricImageLinks = {
  fallbackLogo: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/website/pp-logo-black-cap.png'
}

export const flagsUrlOntheGCP = [
  { flag: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/templates/Service-Center/Indonesia.svg', lang: 'id', countryCode: '62' },
  // { flag: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/templates/Service-Center/Vietnam.svg', lang: 'vi', countryCode: '62' },
  // { flag: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/templates/Service-Center/Thailand.svg', lang: 'th', countryCode: '66' },
  { flag: 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/templates/Service-Center/United%20Kingdom.svg', lang: 'en', countryCode: '84' }
]

export const listLangVietEng = [
  { lang: 'vi', countryCode: '62', displayName: 'English' },
  { lang: 'en', countryCode: '84', displayName: 'Vietnamese' }
]

export const profileRenderMenu = [
  { title: LANG_STRINGS.profile_details, link: '/profile', img: ProfileIcon },
  { title: LANG_STRINGS.document_details, link: '/documents', img: DocumentIcon }
]

export const b2b2cUser = 'b2b2c_user'
export const tapinsuranceUser = 'tapinsurance_user'

export const agencyAgent = 'agency_agent'
export const agencyCustomer = 'agency_customer'

export const agencyPolicyLink = 'agency-policy'
export const polisLink = 'polis'

export const tabKeyMap = {
  'polis': 'polis',
  'claim': 'claim',
  'agencyPolis': 'agency-policy',
  'agencyClaim': 'agency-claim'
}

export const benefitSteps = {
  loading: 'loading',
  singleBenefitList: 'singleBenefitList',
  multiBenefitList: 'multiBenefitList',
  addOnQuestionList: 'addOnQuestionList',
  beneficeryUserList: 'beneficeryUserList',
  errorBenefitMessage: 'errorBenefitMessage',
  validateOrCreateClaimMessage: 'validateOrCreateClaimMessage',
  tapTravelUserList: 'tapTravelUserList',
  tsiInfoBanner: 'tsiInfoBanner',
  secondClaimOnSameBenefit: 'secondClaimOnSameBenefit'
}
export const PolicyTabs = [
  { title: LANG_STRINGS.allPolicy, filter: '', mobileTitle: LANG_STRINGS.all },
  { title: LANG_STRINGS.activePolicy, filter: 'ACTIVE', mobileTitle: LANG_STRINGS.active },
  { title: LANG_STRINGS.expiredPolciy, filter: 'INACTIVE', mobileTitle: LANG_STRINGS.expired }
]

export const AgencyTabs = [
  { title: LANG_STRINGS.allPolicy, filter: '', mobileTitle: LANG_STRINGS.all },
  { title: LANG_STRINGS.activePolicy, filter: 'ACTIVE', mobileTitle: LANG_STRINGS.active },
  { title: LANG_STRINGS.expiredPolciy, filter: 'EXPIRED', mobileTitle: LANG_STRINGS.expired }
]

export const ClaimTabs = [
  { title: LANG_STRINGS.allClaims, filter: '', mobileTitle: LANG_STRINGS.all },
  { title: LANG_STRINGS.initatedClaim, filter: 'initiated', mobileTitle: LANG_STRINGS.initiated },
  { title: LANG_STRINGS.setteldClaim, filter: 'after-documents', mobileTitle: LANG_STRINGS.transition },
  { title: LANG_STRINGS.rejectedClaim, filter: 'settled', mobileTitle: LANG_STRINGS.closed }
]

export const setteledClaimsStauses = ['settled', 'claim_rejected']

export const claimsNotInIntiatedSetteledAndRejected = ['settled', 'claim_rejected', 'initiated']

export const afterDocumentsClaimStatuses = ['document_pending', 'document_received', 'reprocess', 'document_verified', 'work_order_released', 'claim_payment_paid', 'salvage_pending', 'salvage_dispatched', 'salvage_received', 'salvage_verified', 'survey_pending', 'survey_complete', 'vehicle_received_by_workshop', 'work_job_completed', 'waiting_dpending_assessment_from_service_center', 'device_assessment_done', 'repair_in_progress_by_service_center', 'repair_complete_by_service_center', 'pending_device_recieved_by_customer', 'claim_cancelled_by_customer', 'approved', 'awaiting_work_order_approval', 'document_complete', 'claim_pending_from_pasarpolis', 'claim_pending_from_provider', 'claim_accepted', 'claim_payment_pending']

export const STATUS_GROUP_INITIATED = 'initiated'
export const STATUS_GROUP_DOCUMENT_PENDING = 'document_pending'
export const STATUS_GROUP_DOC_RECEIVED = 'document_received'
export const STATUS_GROUP_DOC_REPROCESS = 'document_reprocess'
export const STATUS_GROUP_DOC_VERIFIED = 'document_verified'
export const STATUS_GROUP_WORK_ORDER_RELEASED = 'work_order_released'
export const STATUS_GROUP_APPROVED = 'approved'
export const STATUS_GROUP_SETTLED = 'settled'
export const STATUS_GROUP_REJECTED = 'rejected'
export const STATUS_GROUP_SALVAGE_PENDING = 'salvage_pending'
export const STATUS_GROUP_SALVAGE_DISPATCHED = 'salvage_dispatched'
export const STATUS_GROUP_SALVAGE_RECEIVED = 'salvage_received'
export const STATUS_GROUP_SALVAGE_VERIFIED = 'salvage_verified'
export const STATUS_GROUP_ON_SURVEY = 'on_survey'
export const STATUS_GROUP_AWAITING_WORK_ORDER_APPROVAL = 'awaiting_work_order_approval'
export const STATUS_GROUP_REPAIR_PROCESS = 'repair_process'
export const STATUS_GROUP_VEHICLE_RECEIVED = 'vehicle_received'
export const STATUS_GROUP_VEHICLE_AWAITED = 'vehicle_awaited'
export const STATUS_GROUP_SERVICE_CENTER_SURVEY = 'service_center_survey'
export const STATUS_GROUP_SERVICE_CENTER_WORK_IN_REPAIR = 'service_center_work_in_repair'
export const STATUS_GROUP_REPAIR_COMPLETE_BY_SERVICE_CENTER = 'repair_complete_by_service_cennter'
export const STATUS_GROUP_DEVICE_DELIVERY = 'device_delivery_in_progress'
export const STATUS_GROUP_CLAIM_CANCELLED = 'claim_cancelled'

export const mapStatusGroupTextCOLOR = {
  [STATUS_GROUP_INITIATED]: COLORS.originGold,
  [STATUS_GROUP_DOCUMENT_PENDING]: COLORS.originGold,
  [STATUS_GROUP_DOC_REPROCESS]: COLORS.mysticVoilet,
  [STATUS_GROUP_REJECTED]: COLORS.crimsonRed,
  [STATUS_GROUP_SETTLED]: COLORS.grassGreen
}
export const mapStatusGroupTextBackGround = {
  [STATUS_GROUP_INITIATED]: COLORS.lightYellow,
  [STATUS_GROUP_DOCUMENT_PENDING]: COLORS.lightYellow,
  [STATUS_GROUP_DOC_REPROCESS]: COLORS.lightVoilet,
  [STATUS_GROUP_REJECTED]: COLORS.lightRed,
  [STATUS_GROUP_SETTLED]: COLORS.lightGreen
}

export const CHRONOLOGYFIELDITEMS = ['chronology', 'chronologies']

export const CLAIMFORMICONS = {
  'date': 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/star-Calendar.svg',
  'year': 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/star-Calendar.svg',
  'time': 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/Clock.svg',
  'string': 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/Edit.svg',
  'text': 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/Edit.svg',
  'default': 'https://pp-img-prod.s3.ap-southeast-3.amazonaws.com/claim_portal/Edit.svg'
}

export const BOOLEANOPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
]

export const FORMFIELDTYPES = {
  BOOLEAN: 'boolean',
  DISCLAIMER: 'disclaimer',
  CHECKBOX: 'checkbox',
  choices: 'choices',
  ASTERISK: 'asterisk',
  CHOICESEXTERNAL: 'choices_external',
  YEAR: 'year',
  DATE: 'date',
  SKETCH: 'sketch',
  STRING: 'string',
  IMAGE: 'image',
  TIME: 'time',
  CLAIM_AMOUNT: 'claim_amount',
  NIK_NUMBER: 'nik_number',
  DISCLAIMER_AUS: 'disclaimer_aus',
}

export const serviceCenterFormTitle = 'servicecenter-branch-details'

export const workshopSelectionFormTitle = 'workshop-selection'

export const bankDeatilsFormTitle = 'bank-details-form'
export const bankDetailFormTitleV2 = 'bank-details'
export const goPayWalletFormName = 'bank-details-gopay-wallet'

export const servicecenterFormAttributes = {
  provinceConst: 'sc_province',
  brandConst: 'sc_brand',
  cityConst: 'sc_city',
  postalCodeConst: 'sc_postal_code',
  serviceCenterConst: 'service_center',
  serviceBranchCenterConst: 'servicecenter_branch',
  workshopConst: 'sc_workshop'
}
